<script>
import AppDisplay from '@/components/AppDisplay.vue'
import { opcoesFonteFinanciamento } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay
  },
  props: {
    financiamento: {
      type: Object
    }
  },
  methods: {
    formataFonteFinanciamento (values) {
      if (!values || !values.length) return ''
      const fontesFormatadas = values.filter(value => value !== 'OUTRO')
      return fontesFormatadas.map(value => opcoesFonteFinanciamento.find(opcao => opcao.id === value)?.nome).join(', ')
    }
  }
}
</script>

<template>
  <div>
    <div class="mt-2">
      <span class="title-praticas">Dados do financiamento</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Fonte de financiamento:" :content="formataFonteFinanciamento(financiamento.financiamentos)" />
      </el-col>
      <el-col :span="12">
        <app-display v-if="financiamento.financiamentos.length && financiamento.financiamentos.includes('OUTRO')" label="Outra fonte de financiamento:" :content="financiamento.outroFinanciamento" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Financiamento.vue